export default "__VITE_ASSET__DmJ1izqC__"